import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IconDownload } from "@tabler/icons-react";

import { Input, Text } from "@fragments";

import { getExportFields, EXPORT_FORMATS } from "../enums";

import "./styles.scss";

export default function ExportMembersView({
  ModalComponent,
  open,
  onClose,
  format,
  setFormat,
  fields,
  toggleField,
  submitting,
  canSubmit,
  onSubmit,
}) {
  const { t } = useTranslation("memberModals");

  const exportFields = useMemo(() => getExportFields(t), [t]);

  return (
    <ModalComponent
      maxWidth={520}
      open={open}
      handleClose={onClose}
      loading={submitting}
      disabled={!canSubmit}
      title={t("exportMembers.title")}
      bottomButtonSumbitText={t("exportMembers.submit")}
      bottomButtonSumbitIcon={<IconDownload size={18} stroke={2} />}
      bottomButtonCancelText={t("common:actions.cancel")}
      handleSubmit={onSubmit}
      bodyComponent={
        <div className="export-members px-4 py-3">
          <Text.h4 contrast={8} weight={500}>
            {t("exportMembers.format.title")}
          </Text.h4>
          <Text.span contrast={5}>
            {t("exportMembers.format.description")}
          </Text.span>

          <Input.Select
            className="mt-2"
            label={t("exportMembers.format.label")}
            value={format}
            onInput={setFormat}
            options={EXPORT_FORMATS.map((f) => ({
              label: f.label,
              value: f.id,
            }))}
          />

          <div className="export-members__divider" />

          <Text.h4 contrast={8} weight={500}>
            {t("exportMembers.fields.title")}
          </Text.h4>
          <Text.span contrast={5}>
            {t("exportMembers.fields.description")}
          </Text.span>

          <div className="export-members__fields mt-2">
            {exportFields.map((field) => (
              <Input.Switch
                key={field.id}
                label={field.label}
                value={fields.includes(field.id)}
                onInput={(enabled) => toggleField(field.id, enabled)}
              />
            ))}
          </div>
        </div>
      }
    />
  );
}
